import React from "react";

// import schoolVideo from "../assets/video/about-school.mp4";

import classes from "./LeftSide.module.css";

const LeftSide = () => {
  return (
    <div className={classes["wrapper"]}>
      {/* <video src={schoolVideo}></video> */}
    </div>
  );
};

export default LeftSide;
